<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">MyToken设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>查看行情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <!-- <div class="page-actions">
      <create-banner></create-banner>
    </div>
    <banner-list></banner-list> -->
      <list @refresh="getTickers"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import List from './list';
import { mapActions } from 'vuex';

export default {
  name: 'MyTokenTicker',
  components: {
    List
  },
  methods: {
    ...mapActions('myTokenTicker', ['getTickers'])
  },
  created() {
    this.getTickers();
  }
};
</script>

<style lang="less" scoped></style>
